module.exports = __webpack_public_path__ + "img/customer-icon-7.9c5a9be6.png";